import { useMemo } from "react";
import { useParams } from "react-router";

export enum EntityPageMode {
  create = "create",
  edit = "edit",
  clone = "clone",
  view = "view"
}

type InternalEntityPathParams = {
  id?: string,
  mode?: EntityPageMode
}

export type EntityPathParams = {
  id: number | null,
  mode: EntityPageMode
}

function normalizeBasePath(basePath: string) {
  return `${basePath}${basePath.endsWith("/") ? "" : "/"}`;
}

export function getCreatePathTemplate(basePath: string) {
  return `${normalizeBasePath(basePath)}create`;
}

export function getEntityPathTemplate(basePath: string) {
  return `${normalizeBasePath(basePath)}:id/:mode`;
}

export function useEntityPageParams(): EntityPathParams {
  const params = useParams<InternalEntityPathParams>();
  const id = Number.isNaN(Number(params.id)) ? -1 : Number(params.id);

  return useMemo(() => {
    if (!params.id) {
      return {
        id: 0,
        mode: EntityPageMode.create,
      };
    }

    return ({
      id,
      mode: !params.mode ? EntityPageMode.view : params.mode,
    });
  }, [ params.id, id, params.mode ]);
}
